import Service from '../Service';

const resource = "processsampling/";


export default{

    save(prd, requestID) {
        return Service.post(resource + "save", prd, {
            params: { requestID: requestID },
        });
    },
    pagination(parameters, requestID) {
        return Service.post(resource + "pagination", parameters, {
            params: { requestID: requestID },
        });
    },
    list(obj, requestID) {
        return Service.post(resource + "list", obj, {
            params: { requestID: requestID },
        });
    },

    lst(obj, requestID){
        return Service.post(resource + "lst", obj,{
            params: {requestID: requestID},
        });
    },
    listdetail(prd, requestID) {
        return Service.post(resource + "listdetail", prd, {
            params: { requestID: requestID },
        });
    },
    listPeriod(prd, requestID) {
        return Service.post(resource + "listPeriod", prd, {
            params: { requestID: requestID },
        });
    },
    getLotsByPeriod(prd, requestID) {
        return Service.post(resource + "getLotsByPeriod", prd, {
            params: { requestID: requestID },
        });
    },
    saveProportional(prd, requestID) {
        return Service.post(resource + "saveProportional", prd, {
            params: { requestID: requestID },
        });
    },
};